module.exports = __webpack_public_path__ + "static/media/Overcast.afdb7d8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/weather/Overcast.svg
// module id = 406
// module chunks = 0